import React, { Component, PropTypes } from 'react';
import SectionText from './SectionText';

import cx from 'classnames';

class FiveDays extends Component {
  constructor(props) {
    super(props);
    this.offsetTop = null;
    this.state = {
      visible: false
    }
  }

  componentDidMount() {
    this.offsetTop = this.nodeRef.offsetTop;
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    let supportPageOffset = window.pageXOffset !== undefined;
    let isCSS1Compat = ((document.compatMode || '') === 'CSS1Compat');
    let scroll = {
      x: supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft,
      y: supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop,
      winHeight: window.innerHeight
    };

    // Animate the component when it's mostly visible.
    if (scroll.y > (this.offsetTop - scroll.winHeight * 0.4)) {
      this.setState({ visible: true });
    }
  }

  render() {
    let cssClass = `icon day-${this.props.day} center-block`;
    let columnCssClass = "col-md-2 step";
    if (this.props.day === '4') {
      columnCssClass = "col-md-3 step";
    }

    return (
      <div ref={(node) => { this.nodeRef = node; }} className={cx(columnCssClass, { 'animated': this.state.visible })}>
        <div className={ cssClass }></div>
        <h4>Day { this.props.day }</h4>
        <p>{ this.props.body }</p>
        { this.props.children }
      </div>
    )
  }
}

FiveDays.propTypes = {
  day: PropTypes.string.isRequired
};

export default FiveDays;



/** WEBPACK FOOTER **
 ** ./src/components/presentational/FiveDays.jsx
 **/